import { useEffect, useState } from 'react';
import { industryConfigsService, TemplateEntityType } from '@/services/industry-configs.service';

export interface IndustryTemplateSummary {
  fields: number;
  byEntity: Record<TemplateEntityType, number>;
}

/** Default-field counts per industry key (active templates only). */
export function useIndustryTemplates() {
  const [templates, setTemplates] = useState<Record<string, IndustryTemplateSummary> | null>(null);
  useEffect(() => {
    let cancelled = false;
    industryConfigsService.list()
      .then((rows) => {
        if (cancelled) return;
        const out: Record<string, IndustryTemplateSummary> = {};
        for (const t of rows) {
          if (t.isActive === false) continue;
          const byEntity: Record<TemplateEntityType, number> = { lead: 0, contact: 0, deal: 0 };
          for (const f of t.fields) byEntity[f.entityType] += 1;
          out[t.industryKey] = { fields: t.fields.length, byEntity };
        }
        setTemplates(out);
      })
      .catch(() => { if (!cancelled) setTemplates({}); });
    return () => { cancelled = true; };
  }, []);
  return templates;
}
